export var MetaProductType;
(function (MetaProductType) {
    MetaProductType["Software"] = "2";
})(MetaProductType || (MetaProductType = {}));
